import React from "react";

import { useTranslation } from 'react-i18next';
import { renderToString } from 'react-dom/server';
import CanvasJSReact from "../../../utils/canvasjs.react"
import { quantityTransformer } from '../../../utils/tools'

var CanvasJSChart = CanvasJSReact.CanvasJSChart


const BayphoneCanvasChart = (props) => {
    const { t } = useTranslation('bayphone')
    const { symbol, precision, title, dataPoints, month, } = props;
    const totalLabel = t("Total")

    const chartColors = ["#35acda", "#2678dd", "#BAD6F7"];
    CanvasJSReact.CanvasJS.addColorSet("bayphoneDashboardColors", chartColors);

    const toolTipContentFormatter = (toolTipContent) => {
        var totalValue = 0.0;

        function incTotalValue(aValue) {
            totalValue += aValue;
        }

        if (toolTipContent.entries.length > 0) {
            let classGrid = "row grid grid-cols grid-flow-col auto-cols-min";

            if (toolTipContent.entries.length < 20) {
                classGrid = "ToolTipDetail";
            }

            return renderToString(
                <div className="container">
                    <div key={"tooltipHeader"} style={{ paddingBottom: '7px' }}>
                        <strong>{toolTipContent.entries[0].dataPoint.label}</strong><br />
                    </div>
                    <div className={classGrid} key={"tooltipPlanned"} style={{ paddingTop: '7px' }}>
                        {toolTipContent.entries.map((entry) =>
                            (entry.dataPoint.showInTooltip && !entry.dataPoint.sumTotals) ? (
                                <div key={'_' + entry.dataPoint.y} style={{ paddingLeft: '15px' }}>
                                    <div style={{ display: "inline-block", backgroundColor: entry.dataSeries.color, width: "12px", height: "12px" }}></div>
                                    {" " + entry.dataSeries.name + ": "}
                                    <strong>{`${symbol || ''} ${quantityTransformer(entry.dataPoint.y, precision || 0)}`}</strong><br />
                                </div>
                            ) : null
                        )}
                    </div>
                    <div className={classGrid} style={{borderTop: '1px solid #000', paddingTop: '7px'}} key={"tooltipBody"}>
                        {toolTipContent.entries.map((entry) =>
                            (!entry.dataPoint.showInTooltip || !entry.dataPoint.sumTotals) ? null : (
                                <div key={'_' + entry.dataPoint.y} style={{ paddingLeft: '15px' }}>
                                    {incTotalValue(entry.dataPoint.y)}
                                    <div style={{ display: "inline-block", backgroundColor: entry.dataSeries.color, width: "12px", height: "12px" }}></div>
                                    {" " + entry.dataSeries.name + ": "}
                                    <strong>{`${symbol || ''} ${quantityTransformer(entry.dataPoint.y, precision || 0)}`}</strong><br />
                                </div>
                            )
                        )}
                    </div>
                    <div key={"tooltipFooter"} style={{ paddingTop: '7px' }}>
                        <strong style={{ paddingLeft: '30px' }}>{`${totalLabel}:  ${symbol || ''} ${quantityTransformer(totalValue, precision || 0)}`}</strong><br />
                    </div>
                </div>
            )
        }
        else {
            return "";
        }
    }

    const options = {
        animationEnabled: true,
        colorSet: "bubbleColors",
        title: {
            text: title,
            fontFamily: "Arial",
            fontSize: 20,
            fontColor: "#051f34"
        },
        axisY: {
            includeZero: true,
            gridThickness: 0,
            tickLength: 0,
            lineThickness: 0,
            enabled: false,
            labelFormatter: function (e) {
                return "";
            }
        },
        axisX: {
            labelAngle: month > 7 ? -90 : 0,
        },
        legend: {
            horizontalAlign: "right",
            verticalAlign: "center",
            fontSize: 14,
            reversed: true
        },
        toolTip: {
            shared: true,
            contentFormatter: toolTipContentFormatter
        },
        data: dataPoints,
    };

    return <CanvasJSChart 
            options={options}
            containerProps={{ height: "300px", width: "100%" }}
        />;
}

export default BayphoneCanvasChart;